import { Directive, Input, HostListener, ElementRef } from '@angular/core';
import { HostBinding } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Directive({ selector: '[validIfEmpty]' })
export class ValidateValidDirective {
    private _internal: AbstractControl

    @HostListener('keyup') onKeyup() {
        const v = this.el.nativeElement.value
        if (!v) {
            this._internal.setErrors(null)
        }
    }

    @Input() get validIfEmpty(): AbstractControl {
        return this._internal
    }
    set validIfEmpty(value) {
        if (!(value instanceof AbstractControl)) {
            throw new Error('must be an AbstractControl')
        }
        this._internal = value
    }

    constructor(private el: ElementRef) {}
}

